import React, { useState } from 'react';
import {
  Search,
  Image as ImageIcon,
  ClipboardPaste,
  Usb,
  AlertTriangle,
  LayoutGrid,
} from 'lucide-react';
import dayjs from 'dayjs';
import { PageHeader } from '../components/ui/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsList, TabsTrigger } from '../components/ui/tabs';
import { EmptyState } from '../components/ui/empty-state';

function SearchPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [results] = useState([]);
  const [activeTab, setActiveTab] = useState('all');

  const handleSearch = async () => {
    alert(`Searching for: ${searchQuery}`);
  };

  const getIcon = (type) => {
    const cls = 'h-5 w-5';
    switch (type) {
      case 'screenshot':
        return <ImageIcon className={`${cls} text-primary`} />;
      case 'clipboard':
        return <ClipboardPaste className={`${cls} text-primary`} />;
      case 'usb':
        return <Usb className={`${cls} text-warning`} />;
      case 'incident':
        return <AlertTriangle className={`${cls} text-destructive`} />;
      default:
        return <LayoutGrid className={`${cls} text-muted-foreground`} />;
    }
  };

  return (
    <div className="mx-auto flex max-w-[1400px] flex-col gap-6">
      <PageHeader title="Search & Filter" description="Search across all monitoring data" />

      <Card>
        <CardContent className="space-y-4 pt-6">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder="Search screenshots, clipboard, applications..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                className="pl-9"
              />
            </div>
            <Button onClick={handleSearch}>Search</Button>
          </div>

          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList>
              <TabsTrigger value="all">All</TabsTrigger>
              <TabsTrigger value="screenshots">Screenshots</TabsTrigger>
              <TabsTrigger value="clipboard">Clipboard</TabsTrigger>
              <TabsTrigger value="usb">USB</TabsTrigger>
              <TabsTrigger value="incidents">Incidents</TabsTrigger>
            </TabsList>
          </Tabs>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Search Results</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {results.length === 0 ? (
            <EmptyState
              icon={Search}
              title="No results"
              description="Enter a search query to find events"
            />
          ) : (
            <ul className="divide-y divide-border">
              {results.map((result, index) => (
                <li key={index} className="flex items-center gap-3 p-4">
                  {getIcon(result.type)}
                  <div className="min-w-0 flex-1">
                    <div className="text-sm text-foreground">{result.description}</div>
                    <div className="text-xs text-muted-foreground">
                      {dayjs(result.timestamp).format('MMM DD, YYYY HH:mm')}
                    </div>
                  </div>
                  <Badge variant="outline">{result.type}</Badge>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default SearchPage;
